import { useState } from "react";
import {
  INDEX_IS_LIVE,
  INDEX_MINT,
  INDEX_NAME,
  INDEX_SYMBOL,
  SOLSCAN,
  STONKFUN_TOKEN,
} from "../lib/data";

export default function TokenPage() {
  const [copied, setCopied] = useState(false);

  async function copyCa() {
    if (!INDEX_MINT) return;
    try {
      await navigator.clipboard.writeText(INDEX_MINT);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* ignore */
    }
  }

  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell readable">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Token
        </p>
        <h2 className="section-title">{INDEX_SYMBOL}</h2>
        <p className="section-lead" style={{ marginLeft: 0, textAlign: "left" }}>
          {INDEX_NAME} — the fund share. Standard StonkFun fee coin, 2% tier.
        </p>

        <div className="panel" style={{ marginBottom: "1rem" }}>
          <div className="token-hero">
            <img src="/brand/stonkindex-token-1x1.png" alt={`${INDEX_SYMBOL} logo`} />
            <div>
              <h3 style={{ margin: "0 0 0.35rem", fontSize: "1.35rem" }}>
                {INDEX_NAME}
                {INDEX_IS_LIVE ? (
                  <span className="mint-badge mint-badge--live">Live</span>
                ) : (
                  <span className="mint-badge">Soon</span>
                )}
              </h3>
              <p style={{ margin: 0, color: "var(--color-muted)" }}>
                Creator fees fund the rotating basket. Holders receive the
                airdrop — not StonkFun auto reward-tax mode.
              </p>
            </div>
          </div>

          <div className="ca-box" style={{ marginBottom: 0 }}>
            <span
              className="mono"
              style={{
                flex: 1,
                wordBreak: "break-all",
                color: INDEX_MINT ? undefined : "var(--color-faint)",
              }}
            >
              {INDEX_MINT || "Contract address drops at launch"}
            </span>
            {INDEX_MINT ? (
              <>
                <button type="button" className="btn btn-ghost" onClick={copyCa}>
                  {copied ? "Copied" : "Copy CA"}
                </button>
                <a className="btn btn-lime" href={STONKFUN_TOKEN} target="_blank" rel="noreferrer">
                  Trade →
                </a>
                <a className="btn btn-ghost" href={SOLSCAN} target="_blank" rel="noreferrer">
                  Solscan
                </a>
              </>
            ) : null}
          </div>
        </div>

        <div className="two-col">
          <div className="panel">
            <h3>Fee design</h3>
            <div className="stat-row">
              <span>Mode</span>
              <strong>standard</strong>
            </div>
            <div className="stat-row">
              <span>Pool fee</span>
              <strong>2%</strong>
            </div>
            <div className="stat-row">
              <span>Creator share</span>
              <strong>~1.5% / trade</strong>
            </div>
            <div className="stat-row">
              <span>Quote</span>
              <strong>SOL</strong>
            </div>
          </div>
          <div className="panel">
            <h3>Links</h3>
            <p style={{ margin: 0, color: "var(--color-muted)" }}>
              Trade on StonkFun, verify the mint on Solscan, or swap via Jupiter
              from the Swap page once the CA is live.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
